import {
  Box,
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  ErrorBoundary,
  Icon,
  Text
} from "@prismicio/editor-ui"
import { type ReactElement, Suspense } from "react"

import { type Filter, type FilterType } from "./useActionBar"

interface FilterDropDownProps {
  selectedFilters: Filter[]
  type: FilterType
  onFilterSelected: (newFilterId: string, filterType: FilterType) => void
  optionsFetcher: () => { id: string; label: string; key: string }[]
}

export function FilterDropDown(props: FilterDropDownProps) {
  const { selectedFilters, onFilterSelected, optionsFetcher, type } = props

  const options = optionsFetcher()

  function itemIsSelected(item: string) {
    return selectedFilters?.some((filter) => filter.value === item)
  }

  return (
    <DropdownMenu modal>
      <DropdownMenuTrigger>
        <Button
          invisible
          textWeight="normal"
          color="grey"
          endIcon="arrowDropDown"
        >
          {getButtonText(selectedFilters, type)}
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="start" maxHeight={256}>
        {options.map((filter) => (
          <DropdownMenuItem
            key={filter.key}
            onSelect={() => onFilterSelected(filter.id, type)}
            endIcon={
              itemIsSelected(filter.key) && (
                <Icon name="check" size="extraSmall" />
              )
            }
          >
            <Box padding={4}>
              <Text>{filter.label}</Text>
            </Box>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

function getButtonText(filters: Filter[], type: FilterType) {
  const filtersLength = filters?.length

  switch (type) {
    case "customType":
      return filtersLength ? `Type (${filtersLength})` : "Type"
    case "tag":
      return filtersLength ? `Tags (${filtersLength})` : "Tags"
    case "author":
      return filtersLength ? `Authors (${filtersLength})` : "Authors"
  }
}

interface FilterDropDownBoundary {
  children: ReactElement<FilterDropDownProps>
  type: FilterType
  selectedFilters: Filter[]
}

export function FilterDropDownBoundary(props: FilterDropDownBoundary) {
  const { children, type, selectedFilters } = props

  return (
    <ErrorBoundary
      renderError={() => (
        //TODO extract in future ticket PBD-1097
        <Button
          invisible
          textWeight="normal"
          color="grey"
          endIcon="arrowDropDown"
        >
          {getButtonText(selectedFilters, type)}
        </Button>
      )}
    >
      <Suspense
        fallback={
          //TODO extract in future ticket PBD-1097
          <Button
            invisible
            textWeight="normal"
            color="grey"
            endIcon="arrowDropDown"
          >
            {getButtonText(selectedFilters, type)}
          </Button>
        }
      >
        {children}
      </Suspense>
    </ErrorBoundary>
  )
}
